import { chooseTheme } from "./themes";

export const theme = chooseTheme();

export * from "./files";
export * from "./icons";
export * from "./images";
